import { io, Socket } from 'socket.io-client';

const API_BASE_URL = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' && window.location.port === '3000' ? `http://${window.location.hostname}:8000` : (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:8000'));

class SocketService {
    private socket: Socket | null = null;
    private currentRoom: string | null = null;

    connect() {
        if (!this.socket) {
            this.socket = io(API_BASE_URL, {
                transports: ['websocket'],
                reconnectionAttempts: 5,
                reconnectionDelay: 1000,
            });

            this.socket.on('connect', () => {
                console.log('[Socket] Connected');
                if (this.currentRoom) {
                    this.joinTask(this.currentRoom);
                }
            });

            this.socket.on('disconnect', () => {
                console.log('[Socket] Disconnected');
            });

            this.socket.on('connect_error', (err) => {
                console.error('[Socket] Connection Error:', err.message);
            });
        }
    }

    joinTask(taskId: string) {
        this.currentRoom = taskId;
        if (this.socket && this.socket.connected) {
            this.socket.emit('join_task', taskId);
        } else {
            this.connect();
        }
    }

    onProgress(callback: (data: { stage: string; percent: number }) => void) {
        if (!this.socket) this.connect();
        this.socket?.on('progress', callback);
    }

    onCompleted(callback: (result: any) => void) {
        if (!this.socket) this.connect();
        this.socket?.on('completed', callback);
    }

    offAllHandlers() {
        if (this.socket) {
            this.socket.off('progress');
            this.socket.off('completed');
        }
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
            this.currentRoom = null;
        }
    }
}

export const socketService = new SocketService();
export default socketService;
